<template>
  <div class="menzhenjiaofeijilu">
    <van-cell title="选择日期区间" :value="`${startDate} ~ ${endDate}`" @click="show = true" />
    <van-calendar
      v-model="show"
      type="range"
      color="#1989fa"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onConfirm"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length ? '没有更多了' : ''"
    >
      <div v-for="item in list" :key="item.id" class="view-box-container">
        <div class="view-box" :class="item.status==='2' ? 'view-bj' : ''">
          <div v-if="item.jslx !== '1' && item.jslx!=='2'" class="view-text-box">
            <span class="view-item">科室：</span>
            <span class="view-text">{{ item.orgnameDiag || '--' }}</span>
          </div>
          <div v-if="item.jslx !== '1' && item.jslx!=='2'" class="view-text-box">
            <span class="view-item">就诊医生：</span>
            <span class="view-text">{{ item.empnameDiag || '--' }}</span>
          </div>
          <div class="view-text-box">
            <span class="view-item">缴费金额：</span>
            <span class="view-text">￥{{ item.amount }}</span>
          </div>
          <div class="view-text-box">
            <span class="view-item">缴费时间：</span>
            <span class="view-item">{{ timeFormat(item.dateRek) }}</span>
            <span class="view-text" style="float:right">
              <span v-if="item.dateCanl" class="view-text-box  view-text-fail">已退费</span>
              <span v-else class="view-text-box view-text-success">已缴费</span>
            </span>
          </div>
        </div>
        <!-- <div class="box-bottom">
          <div v-if="item.status==='1' || item.status==='2'" class="bom-btn" @click="todzpz(item.id)">电子凭证</div>
          <div class="bom-btn" @click="toMingxi(item.clinicNo)">缴费明细</div>
        </div> -->
      </div>
    </van-list>
    <NoData v-if="!loading && list.length === 0" />
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MenZhenJiaoFeiJiLu',
  data() {
    return {
      current: 1,
      pageSize: 10,
      list: [],
      loading: false,
      finished: false,
      startDate: moment().subtract(30, 'day').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      show: false,
      minDate: new Date('2020/1/1'),
      maxDate: new Date()
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    timeFormat(dateTime) {
      if (dateTime) { return moment(dateTime).format('YYYY-MM-DD HH:mm:ss') } else return '--'
    },
    getList() {
      this.loading = true
      const obj = {
        endDate: this.endDate,
        idCard: this.$route.query.patientSfzh,
        startDate: this.startDate,
        type: ''
      }
      this.$Apis.chargeList(obj).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.list = res.data.infos
        }
        this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    todzpz(id) {
      // this.$router.push(`/dianzipingzheng?id=${id}`)
      this.$Apis.getEinvoiceDetailsById({ Id: id }).then(res => {
        if (res.code === 200) {
          window.location.href = res.data.dzpjurl
        } else {
          this.$toast(res.message)
        }
      })
    },
    toMingxi(id) {
      this.$router.push(`/jiaofeimingxi?id=${id}`)
    },
    onConfirm(date) {
      const [start, end] = date
      this.show = false
      this.startDate = moment(start).format('YYYY-MM-DD')
      this.endDate = moment(end).format('YYYY-MM-DD')
      this.getList()
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.view-box-container {
  margin: 0.1rem;
  padding: 8px 18px;
  background: #fff;
  border-radius: 0.1rem;
  overflow: hidden;
  // padding: .05rem 0;
  // margin-top: .05rem;
  // margin-bottom: .05rem;
  // background: #ffffff;
  // border-radius: .04rem;
}

.view-item {
  font-size: .17rem;
}

.view-text {
  font-size: .17rem;
  color: #888888;
  // line-height: 39px;
}

.view-bj {
  background: url('/images/yizuofei.png') no-repeat right .2rem top .1rem / .5rem .5rem;
}

.view-box {
  margin-top: .1rem;
}

.view-text-box {
  line-height: 1.2;
  font-size: .14rem;
  margin-bottom: .15rem;
}

.view-text-success {
  font-size: .17rem;
  color: #1078FE;
}

.view-text-fail {
  color: red;
}

.box-right {
  margin-right: .2rem;
}

.box-right .btn {
  background: #1777FF;
  padding: .03rem .05rem;
  border-radius: .015rem;
  font-size: .14rem;
  color: #fff;
  z-index: 999;
}

.box-bottom {
  padding: 0 .15rem .05rem;
  text-align: right;
}

.bom-btn {
  background: #1777FF;
  padding: .03rem .05rem;
  border-radius: .03rem;
  font-size: .14rem;
  color: #fff;
  display: inline-block;
  margin-right: .1rem;
}
</style>
